import script from "./MazdaHomeDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaHomeDashboard.vue?vue&type=script&setup=true&lang=js"

import "./MazdaHomeDashboard.vue?vue&type=style&index=0&id=d0366f7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0366f7a"]])

export default __exports__